<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.62492 4.87501H9.37492C9.44908 4.875 9.52156 4.853 9.58322 4.81179C9.64487 4.77058 9.69292 4.71202 9.7213 4.64351C9.74968 4.575 9.7571 4.49961 9.74264 4.42688C9.72818 4.35414 9.69247 4.28733 9.64005 4.23489L6.26505 0.859888C6.23024 0.825051 6.18891 0.797416 6.14342 0.77856C6.09793 0.759705 6.04916 0.75 5.99992 0.75C5.95068 0.75 5.90191 0.759705 5.85642 0.77856C5.81093 0.797416 5.7696 0.825051 5.7348 0.859888L2.3598 4.23489C2.30737 4.28733 2.27166 4.35414 2.2572 4.42688C2.24274 4.49961 2.25016 4.575 2.27854 4.64351C2.30692 4.71202 2.35497 4.77058 2.41662 4.81179C2.47828 4.853 2.55076 4.875 2.62492 4.87501Z"
      fill="currentColor"
    />
    <path
      d="M9.37492 7.125H2.62492C2.55076 7.12502 2.47828 7.14702 2.41662 7.18822C2.35497 7.22943 2.30692 7.28799 2.27854 7.3565C2.25016 7.42502 2.24274 7.5004 2.2572 7.57314C2.27166 7.64587 2.30737 7.71268 2.3598 7.76513L5.7348 11.1401C5.7696 11.175 5.81093 11.2026 5.85643 11.2214C5.90192 11.2403 5.95068 11.25 5.99992 11.25C6.04916 11.25 6.09792 11.2403 6.14342 11.2214C6.18891 11.2026 6.23024 11.175 6.26505 11.1401L9.64005 7.76513C9.69247 7.71268 9.72818 7.64587 9.74264 7.57314C9.7571 7.5004 9.74968 7.42502 9.7213 7.3565C9.69292 7.28799 9.64487 7.22943 9.58322 7.18822C9.52156 7.14702 9.44908 7.12502 9.37492 7.125Z"
      fill="currentColor"
    />
  </svg>
</template>
<script setup lang="ts">
interface IProps {
  fill?: string;
}

const props = withDefaults(defineProps<IProps>(), {
  fill: "#2FB925",
});
</script>

<script lang="ts">
export default {};
</script>
